import { useEffect } from 'react';
import { useNextMicro, useRefCallback, useSingleton, useUpdate } from '@bydesign-ui/hooks';
import { Option } from '../../../models/select';
import { useSelect } from './useSelect';
import { useOptionGroup } from './useOptionGroup';
export function useOption(data, id, onSearchQuery, onBackFillUpdate) {
  var select = useSelect();
  var optionGroup = useOptionGroup();
  var option = useSingleton(function () {
    return new Option(select, data, id, optionGroup || undefined);
  });
  var update = useNextMicro(useUpdate());
  option.updateOption(data);
  var onSearchQueryCallback = useRefCallback(onSearchQuery);
  var onBackFillUpdateCallback = useRefCallback(onBackFillUpdate);
  useEffect(function () {
    option.addListener('state-updated', update);
    select.addListener('search-query', onSearchQueryCallback);
    select.addListener('back-fill-update', onBackFillUpdateCallback);
    return function () {
      option.removeListener('state-updated', update);
      select.removeListener('search-query', onSearchQueryCallback);
      select.removeListener('back-fill-update', onBackFillUpdateCallback);
      option.dispose();
    };
  }, []);
  return option;
}